import { exponents } from "./grade6/exponents";

const grade6Content = {
    ...exponents,
};

export default grade6Content;
